import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { TeamStructureContainer } from './containers/team-structure/team-structure.container';
import { TeamsListContainer } from './containers/teams-list/teams-list.container';
import { AssignmentSettingsContainer } from './containers/assignment-settings/assignment-settings.container';

const CHILDREN = APP_ROUTES.TEAM_MODULE.CHILDREN as RouteConfig;

export const TeamModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.TEAM_MODULE.FULL_PATH}>
        <Redirect to={CHILDREN.STRUCTURE.FULL_PATH} />
      </Route>
      <Route path={CHILDREN.STRUCTURE.FULL_PATH} component={TeamStructureContainer} />
      <Route path={CHILDREN.LIST.FULL_PATH} component={TeamsListContainer} />
      <Route path={CHILDREN.ASSIGNMENT.FULL_PATH} component={AssignmentSettingsContainer} />
    </>
  );
};
